// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Accounting module — shared layout helpers. Every selector is
   scoped under .acct-module (set once in AccountingRouter).
   ============================================================ */

.acct-module {
  min-width: 0;
}

/* Page header: title + optional actions; actions go full width on phones. */
.acct-module .acct-page-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-3);
  margin-bottom: var(--ds-space-4);
}

.acct-module .acct-page-header__text {
  min-width: 0;
  flex: 1 1 240px;
}

.acct-module .acct-page-header__title.ant-typography {
  margin: 0;
  font-size: var(--ds-title-size);
  overflow-wrap: anywhere;
}

.acct-module .acct-page-header__extra {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2);
  flex: 1 1 100%;
}

.acct-module .acct-page-header__extra > * {
  flex: 1 1 auto;
}

@media (min-width: 768px) {
  .acct-module .acct-page-header__extra {
    flex: 0 1 auto;
    justify-content: flex-end;
  }

  .acct-module .acct-page-header__extra > * {
    flex: 0 0 auto;
  }
}

/* Numbers: tabular figures, never wrap, and keep "−1.234,56 €" in LTR order inside RTL text. */
.acct-module .acct-num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  direction: ltr;
  unicode-bidi: isolate;
}

.acct-module .acct-num--strong {
  font-weight: 600;
}

/* Prominent amount on a phone card / list row. */
.acct-module .acct-amount-lg {
  font-size: 1.05rem;
  font-weight: 600;
}

/* Accounting grids (journal lines, trial balance, statements) keep a table on phones. */
.acct-module .acct-grid .ant-table-cell {
  font-variant-numeric: tabular-nums;
}

/* KPI tiles: values shrink on narrow tiles instead of overflowing. */
.acct-module .acct-kpi {
  height: 100%;
}

.acct-module .acct-kpi .ant-statistic-content {
  font-size: clamp(1.05rem, 4.2vw, 1.5rem);
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.acct-module .acct-kpi .ant-statistic-title {
  overflow-wrap: anywhere;
}

/* Filter toolbar: extra filters collapse into a panel on phones. */
.acct-module .acct-filter-panel {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  width: 100%;
}

.acct-module .acct-filter-panel > * {
  width: 100%;
  min-width: 0;
}

@media (min-width: 768px) {
  .acct-module .acct-filter-panel {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    width: auto;
  }

  .acct-module .acct-filter-panel > * {
    width: auto;
    flex: 0 1 220px;
  }

  .acct-module .acct-filter-panel > .ant-picker-range {
    flex-basis: 260px;
  }
}

/* Document preview + form side by side on desktop, stacked on phones. */
.acct-module .acct-split,
.acct-split {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--ds-space-4);
}

@media (min-width: 992px) {
  .acct-module .acct-split,
  .acct-split {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

/* Touch-sized row actions */
.acct-module .acct-actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

@media (max-width: 767.98px) {
  .acct-module .acct-actions .ant-btn {
    min-height: 40px;
  }
}

/* Long text wraps instead of widening the page. */
.acct-module .acct-wrap {
  overflow-wrap: anywhere;
  min-width: 0;
}

@media (min-width: 768px) {
  .acct-module .page-toolbar__filters > .acct-filter-panel {
    flex: 1 1 auto;
  }
}

/* DATEV export: checkbox at the top of a two-line label */
.acct-module .acct-datev-contents .ant-checkbox-wrapper {
  align-items: flex-start;
}
.acct-module .acct-datev-contents .ant-checkbox {
  align-self: flex-start;
  margin-top: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/accounting/shared/accounting.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,YAAY;AACd;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,+FAA+F;AAC/F;EACE,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wFAAwF;AACxF;EACE,kCAAkC;AACpC;;AAEA,qEAAqE;AACrE;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wEAAwE;AACxE;;EAEE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE;;IAEE,oDAAoD;EACtD;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,kDAAkD;AAClD;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,0DAA0D;AAC1D;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["/* ============================================================\n   Accounting module — shared layout helpers. Every selector is\n   scoped under .acct-module (set once in AccountingRouter).\n   ============================================================ */\n\n.acct-module {\n  min-width: 0;\n}\n\n/* Page header: title + optional actions; actions go full width on phones. */\n.acct-module .acct-page-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-3);\n  margin-bottom: var(--ds-space-4);\n}\n\n.acct-module .acct-page-header__text {\n  min-width: 0;\n  flex: 1 1 240px;\n}\n\n.acct-module .acct-page-header__title.ant-typography {\n  margin: 0;\n  font-size: var(--ds-title-size);\n  overflow-wrap: anywhere;\n}\n\n.acct-module .acct-page-header__extra {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex: 1 1 100%;\n}\n\n.acct-module .acct-page-header__extra > * {\n  flex: 1 1 auto;\n}\n\n@media (min-width: 768px) {\n  .acct-module .acct-page-header__extra {\n    flex: 0 1 auto;\n    justify-content: flex-end;\n  }\n\n  .acct-module .acct-page-header__extra > * {\n    flex: 0 0 auto;\n  }\n}\n\n/* Numbers: tabular figures, never wrap, and keep \"−1.234,56 €\" in LTR order inside RTL text. */\n.acct-module .acct-num {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  direction: ltr;\n  unicode-bidi: isolate;\n}\n\n.acct-module .acct-num--strong {\n  font-weight: 600;\n}\n\n/* Prominent amount on a phone card / list row. */\n.acct-module .acct-amount-lg {\n  font-size: 1.05rem;\n  font-weight: 600;\n}\n\n/* Accounting grids (journal lines, trial balance, statements) keep a table on phones. */\n.acct-module .acct-grid .ant-table-cell {\n  font-variant-numeric: tabular-nums;\n}\n\n/* KPI tiles: values shrink on narrow tiles instead of overflowing. */\n.acct-module .acct-kpi {\n  height: 100%;\n}\n\n.acct-module .acct-kpi .ant-statistic-content {\n  font-size: clamp(1.05rem, 4.2vw, 1.5rem);\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n\n.acct-module .acct-kpi .ant-statistic-title {\n  overflow-wrap: anywhere;\n}\n\n/* Filter toolbar: extra filters collapse into a panel on phones. */\n.acct-module .acct-filter-panel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  width: 100%;\n}\n\n.acct-module .acct-filter-panel > * {\n  width: 100%;\n  min-width: 0;\n}\n\n@media (min-width: 768px) {\n  .acct-module .acct-filter-panel {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    width: auto;\n  }\n\n  .acct-module .acct-filter-panel > * {\n    width: auto;\n    flex: 0 1 220px;\n  }\n\n  .acct-module .acct-filter-panel > .ant-picker-range {\n    flex-basis: 260px;\n  }\n}\n\n/* Document preview + form side by side on desktop, stacked on phones. */\n.acct-module .acct-split,\n.acct-split {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: var(--ds-space-4);\n}\n\n@media (min-width: 992px) {\n  .acct-module .acct-split,\n  .acct-split {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n\n/* Touch-sized row actions */\n.acct-module .acct-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n@media (max-width: 767.98px) {\n  .acct-module .acct-actions .ant-btn {\n    min-height: 40px;\n  }\n}\n\n/* Long text wraps instead of widening the page. */\n.acct-module .acct-wrap {\n  overflow-wrap: anywhere;\n  min-width: 0;\n}\n\n@media (min-width: 768px) {\n  .acct-module .page-toolbar__filters > .acct-filter-panel {\n    flex: 1 1 auto;\n  }\n}\n\n/* DATEV export: checkbox at the top of a two-line label */\n.acct-module .acct-datev-contents .ant-checkbox-wrapper {\n  align-items: flex-start;\n}\n.acct-module .acct-datev-contents .ant-checkbox {\n  align-self: flex-start;\n  margin-top: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
